import { PersonalAssetMetaDataDto } from '../../../../defs/api';
import { SavingsAccountMetaDataMobxDto } from './savings-account-meta-data-mobx-dto';

export class PersonalAssetMetadataDataModel implements PersonalAssetMetaDataDto {
    savingsAccount?: SavingsAccountMetaDataMobxDto;

    static create(dto: PersonalAssetMetaDataDto): PersonalAssetMetadataDataModel {
        const mobxDto = new PersonalAssetMetadataDataModel();
        return Object.assign(mobxDto, dto, {
            savingsAccount: dto.savingsAccount ? SavingsAccountMetaDataMobxDto.create(dto.savingsAccount) : undefined,
        });
    }

    static createFromArray(dtos: PersonalAssetMetaDataDto[]): PersonalAssetMetadataDataModel[] {
        const createdDtos: PersonalAssetMetadataDataModel[] = [];
        dtos.forEach((dto) => {
            createdDtos.push(PersonalAssetMetadataDataModel.create(dto));
        });

        return createdDtos;
    }
}
